import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Box, Container, Typography } from '@mui/material';

import { useTranslations } from "../../../../hooks/useTranslations";

import { useSystemHead, headTitles } from '../../../../hooks/useSystemHead';
import { useAuthAccess, authTargetTypes } from '../../../../hooks/useAuthAccess';

import AppWidgetSummary from './widget/AppWidgetSummary';

import { icons } from "../../../../components/common/CommonIcons"

// import { useAppContextFeatures } from '../../../../context/AppContext';
import { useSystemPrompt } from '../../../../hooks/useSystemPrompt';

import { useProduct } from "../../hooks/model/useProduct"
import { useMarking } from "../../hooks/model/useMarking"

import {
    customInjectionProps as productInjectionProps,
    productLoadStatusTypes
} from '../../schema/items/productSchema';

// ----------------------------------------------------------------------

export default function Dashboard({
    routeType
}) {
    const theme = useTheme();

    const { getHtmlHead } = useSystemHead(routeType)
    const { authData } = useAuthAccess(routeType)

    const { listProducts, filterOperatorTypes } = useProduct({ routeType })
    const { listMarkings } = useMarking({ routeType })

    const { t } = useTranslations({ ns: ["common"] })

    // const { setSystemLoading } = useAppContextFeatures();
    const { promptMessage } = useSystemPrompt();

    const [summary, setSummary] = useState({
        summaryTotalMarking: 0,
        summaryUnloadProduct: 0
    })

    const fetchMarkings = async () => {

        try {

            const props = {
                limit: 1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [

                ],
            }

            // props.branchType = branchTypes.customer

            const { count } = await listMarkings({
                props,
                status: `1`
            })

            setSummary(prev => ({
                ...prev,
                summaryTotalMarking: parseInt(count, 10)
            }))

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

    }

    const fetchUnloadProducts = async () => {

        try {

            const props = {
                limit: 1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: productInjectionProps.loadStatus.retrieveKey,
                        operator: filterOperatorTypes.notEq,
                        value: `${productLoadStatusTypes.loaded.value}`
                    }
                ]
            }

            // props.itemType = itemTypes.product

            // const { data } = await listItems(props)
            const { count } = await listProducts({
                props,
            })

            setSummary(prev => ({
                ...prev,
                summaryUnloadProduct: parseInt(count, 10)
            }))

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

    }

    useEffect(() => {

        fetchUnloadProducts()
        fetchMarkings()

    }, [])

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: t('dashboard') })
            }

            {/* <Container maxWidth="xl"> */}
            <Typography variant="h4" sx={{ mb: 5 }}>
                {t('hiWelcomeBack')} {authData?.displayName}
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={6}>
                    <AppWidgetSummary
                        // title={t("weeklySales")}
                        title={`总共麦头`}
                        total={
                            summary?.summaryTotalMarking
                        }
                        iconName={icons.users}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                    <AppWidgetSummary
                        // title={t("newUsers")}
                        title={`未装柜货物`}
                        total={
                            summary?.summaryUnloadProduct
                        }
                        color="info"
                        iconName={icons.products}
                    />
                </Grid>

                {/* <Grid item xs={12} sm={6} md={6}>
                    <AppWidgetSummary
                        // title={t("itemOrders")}
                        title={``}
                        total={1723315}
                        color="warning"
                        iconName={icons.cashSales}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                    <AppWidgetSummary
                        title={t("bugReports")}
                        total={234}
                        color="error"
                        iconName={icons.cancel}
                    />
                </Grid> */}


            </Grid>
        </Box>
    );
}
